module.exports = __webpack_public_path__ + "img/special_whiteningessence_202403.1bafe30e.jpg";